export default __webpack_public_path__ + "static/media/Mobile Marketing-pana 1.788d51ff.svg";